import React, { useState, useEffect } from 'react';

/**
 * GIẢ LẬP API FETCH (Duy trì để file có thể chạy độc lập trong môi trường preview)
 */
const API_URL = 'http://localhost:5000';

const apiFetchLuongT13 = async (userId, year) => {
  try {
    const response = await fetch(`${API_URL}/api/luong-t13/${userId}/${year}`, {
      credentials: 'include'
    });
    if (!response.ok) throw new Error('Không thể tải dữ liệu');
    return await response.json();
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};

/**
 * Component hiển thị chi tiết phiếu thưởng tháng 13.
 * Đã sửa logic: Ưu tiên hiển thị dữ liệu được truyền vào (propsData) từ Admin.
 */
const App = ({ data: propsData, userId, year }) => {
  const [data, setData] = useState(propsData || null);
  const [loading, setLoading] = useState(!propsData); // Nếu có propsData thì không loading
  const [error, setError] = useState(null);

  const currentYear = year || 2025;

  useEffect(() => {
    // TRƯỜNG HỢP 1: Admin truyền dữ liệu trực tiếp (Tra cứu)
    if (propsData) {
        setData(propsData);
        setLoading(false);
        setError(null);
        return;
    }

    // TRƯỜNG HỢP 2: User xem trên điện thoại (chỉ có userId, cần tự fetch)
    if (!userId) {
        setLoading(false);
        return;
    }

    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const result = await apiFetchLuongT13(userId, currentYear);
        setData(result.data || result);
      } catch (err) {
        setError("Không tìm thấy dữ liệu thưởng.");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [propsData, userId, currentYear]);

  const formatCurrency = (amount) => {
    if (typeof amount !== 'number' || isNaN(amount)) return '0';
    return amount.toLocaleString('vi-VN');
  };

  const DetailRow = ({ label, value, subLabel, colorClass = 'text-gray-800' }) => (
    <div className="flex justify-between items-center py-2.5 border-b border-gray-50 last:border-0">
      <div className="flex flex-col">
        <span className="text-sm font-semibold text-gray-600">{label}</span>
        {subLabel && <span className="text-[10px] text-gray-400">{subLabel}</span>}
      </div>
      <span className={`text-sm font-bold ${colorClass}`}>{value}</span>
    </div>
  );

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50">
        <div className="w-8 h-8 border-2 border-indigo-200 border-t-indigo-600 rounded-full animate-spin mb-2"></div>
        <p className="text-gray-400 text-[10px] font-bold uppercase tracking-widest">Đang tải...</p>
      </div>
    );
  }

  if (error || !data) {
    return (
      <div className="p-8 text-center min-h-screen flex flex-col items-center justify-center bg-gray-50">
        <p className="text-red-500 font-bold mb-2 text-sm">{error || "Chưa chọn nhân viên"}</p>
      </div>
    );
  }

  return (
    <div className="bg-gray-100 min-h-screen font-sans pb-10">
      
      {/* 1. HEADER TINH GỌN */}
      <div className="bg-white px-4 py-3 shadow-sm border-b sticky top-0 z-10 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center text-gray-500 font-bold text-sm">
            {data.HoTen?.charAt(0)}
          </div>
          <div>
            <p className="text-gray-800 font-bold text-xs uppercase leading-tight">{data.HoTen}</p>
            <p className="text-gray-400 text-[10px]">MSNV: {data.MSNV}</p>
          </div>
        </div>
        <div className="text-right">
          <p className="text-[9px] text-gray-400 uppercase font-bold">Thưởng {currentYear}</p>
        </div>
      </div>

      <div className="px-4 space-y-4 mt-4">
        
        {/* 2. CARD THỰC LÃNH */}
        <div className="bg-gradient-to-r from-blue-600 to-indigo-700 rounded-2xl p-5 text-center shadow-lg shadow-blue-200 relative overflow-hidden">
           <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -mr-10 -mt-10 blur-2xl"></div>
           <p className="text-blue-100 text-[10px] font-bold uppercase tracking-widest mb-1 relative z-10">Tổng Thưởng</p>
           <div className="flex justify-center items-baseline gap-1 relative z-10">
             <span className="text-white text-4xl font-black tracking-tighter drop-shadow-sm">
               {formatCurrency(data.ThucLanh)}
             </span>
             <span className="text-blue-200 text-sm font-bold">đ</span>
           </div>
        </div>

        {/* 3. THU NHẬP */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
          <div className="bg-emerald-50 px-4 py-2 border-b border-emerald-100 flex items-center gap-2">
            <div className="w-2 h-2 rounded-full bg-emerald-500"></div>
            <h3 className="text-emerald-800 font-bold text-xs uppercase tracking-wider">Chi tiết thu nhập</h3>
          </div>
          
          <div className="p-4">
            {/* CÔNG THỨC TÍNH THƯỞNG */}
            <div className="mb-6">
              <div className="flex justify-between items-center mb-2">
                 <span className="text-sm font-bold text-gray-700">Thưởng tháng 13</span>
                 <span className="text-lg font-black text-emerald-600">{formatCurrency(data.TienThuongThang13)} <span className="text-xs text-emerald-500">đ</span></span>
              </div>

              {/* Box Highlight */}
              <div className="bg-indigo-50 rounded-xl border border-indigo-100 p-4 relative mt-2">
                <div className="absolute -top-2.5 left-1/2 -translate-x-1/2 bg-white px-3 py-0.5 rounded-full border border-indigo-100 shadow-sm">
                   <span className="text-[9px] font-black text-indigo-500 uppercase tracking-widest">Tham số tính</span>
                </div>

                <div className="grid grid-cols-3 gap-0 mt-2 divide-x divide-indigo-200">
                  <div className="flex flex-col items-center px-1 text-center">
                    <span className="text-[9px] font-bold text-gray-400 uppercase mb-1">Lương tính</span>
                    <span className="text-xs font-black text-gray-800 leading-tight">
                      {formatCurrency(data.LuongTinhThuong)}
                    </span>
                    <span className="text-[8px] text-gray-400">VNĐ</span>
                  </div>
                  <div className="flex flex-col items-center px-1 text-center">
                    <span className="text-[9px] font-bold text-indigo-400 uppercase mb-1">Hệ số</span>
                    <span className="text-2xl font-black text-indigo-600 leading-none">
                      {data.HeSoThuong}
                    </span>
                  </div>
                  <div className="flex flex-col items-center px-1 text-center">
                    <span className="text-[9px] font-bold text-gray-400 uppercase mb-1">Ngày công</span>
                    <span className="text-xs font-black text-gray-800 leading-tight">
                      {data.SoNgayCongThucTe}
                    </span>
                    <span className="text-[8px] text-gray-400">Ngày</span>
                  </div>
                </div>
              </div>
            </div>

            <DetailRow 
              label="Thanh toán phép năm" 
              subLabel={`Tồn: ${data.SoTiengPhepNamConLai} giờ`}
              value={`${formatCurrency(data.TienPhepNam)} đ`} 
              colorClass="text-gray-800 font-bold"
            />
            
            <div className="mt-3 pt-3 border-t border-dashed border-gray-200 flex justify-between items-center">
              <span className="text-xs font-bold text-gray-400 uppercase">Tổng cộng nhận</span>
              <span className="text-base font-black text-emerald-600">{formatCurrency(data.TongCong)} đ</span>
            </div>
          </div>
        </div>

        {/* 4. KHẤU TRỪ */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
          <div className="bg-rose-50 px-4 py-2 border-b border-rose-100 flex items-center gap-2">
            <div className="w-2 h-2 rounded-full bg-rose-500"></div>
            <h3 className="text-rose-800 font-bold text-xs uppercase tracking-wider">Khoản Khấu Trừ</h3>
          </div>
          <div className="p-4">
            <div className="flex justify-between items-start">
               <div className="flex flex-col">
                  <span className="text-sm font-semibold text-gray-700">Khấu trừ khác</span>
                  <span className="text-[10px] text-gray-400 mt-0.5">
                    {data.SoLanBiBienBan > 0 ? (
                      <span className="text-rose-600 font-bold bg-rose-50 px-1.5 py-0.5 rounded">
                        Có {data.SoLanBiBienBan} biên bản vi phạm
                      </span>
                    ) : (
                      "Vi phạm nội quy, khống công..."
                    )}
                  </span>
               </div>
               <span className="text-sm font-black text-rose-500">-{formatCurrency(data.TienTruKhac)} đ</span>
            </div>
          </div>
        </div>

        {/* 5. THÔNG TIN PHỤ */}
        <details className="group">
          <summary className="list-none bg-white p-3 rounded-lg border border-gray-200 flex items-center justify-between cursor-pointer shadow-sm">
            <span className="text-[10px] font-bold text-gray-500 uppercase">Xem chi tiết phụ cấp cơ sở</span>
            <svg className="w-4 h-4 text-gray-400 transition-transform group-open:rotate-180" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path></svg>
          </summary>
          <div className="mt-2 bg-white rounded-lg p-3 border border-gray-100 grid grid-cols-2 gap-x-4 gap-y-2">
            <div className="flex justify-between border-b border-gray-50 pb-1"><span className="text-[10px] text-gray-500">Lương CB</span> <span className="text-[10px] font-bold">{formatCurrency(data.LuongCoBan)}</span></div>
            <div className="flex justify-between border-b border-gray-50 pb-1"><span className="text-[10px] text-gray-500">PC Chức vụ</span> <span className="text-[10px] font-bold">{formatCurrency(data.PhuCapChucVu)}</span></div>
            <div className="flex justify-between border-b border-gray-50 pb-1"><span className="text-[10px] text-gray-500">PC Kỹ thuật</span> <span className="text-[10px] font-bold">{formatCurrency(data.PhuCapKyThuat)}</span></div>
            <div className="flex justify-between border-b border-gray-50 pb-1"><span className="text-[10px] text-gray-500">PC Xăng xe</span> <span className="text-[10px] font-bold">{formatCurrency(data.PhuCapXangXe)}</span></div>
            <div className="flex justify-between border-b border-gray-50 pb-1"><span className="text-[10px] text-gray-500">Hỗ trợ nhà</span> <span className="text-[10px] font-bold">{formatCurrency(data.HoTroNhaO)}</span></div>
            <div className="flex justify-between border-b border-gray-50 pb-1"><span className="text-[10px] text-gray-500">Chuyên cần</span> <span className="text-[10px] font-bold">{formatCurrency(data.ChuyenCan)}</span></div>
            <div className="col-span-2 text-[9px] text-gray-400 text-center pt-2 italic">Ngày vào xưởng: {data.NgayVaoLam}</div>
          </div>
        </details>

        {/* 6. GIẢI THÍCH CÁCH TÍNH (MỚI) */}
        <div className="mt-6 px-1">
          <div className="bg-slate-50 p-4 rounded-xl border border-slate-200 shadow-sm">
            <div className="flex items-center gap-2 mb-3 border-b border-slate-200 pb-2">
              <svg className="w-4 h-4 text-slate-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
              <span className="text-xs font-bold text-slate-1000 uppercase">Tiền thuế TNCN sẽ được tính vào phiếu lương T01/2026</span>
            </div>
            <div className="flex items-center gap-2 mb-3 border-b border-slate-200 pb-2">
              <svg className="w-4 h-4 text-slate-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
              <span className="text-xs font-bold text-slate-700 uppercase">Giải thích cách tính</span>
            </div>
            
            <ul className="space-y-3 text-[10px] text-slate-600 leading-relaxed">
               <li className="flex gap-2 items-start">
                 <span className="text-indigo-500 font-bold">•</span>
                 <div>
                   <span className="font-bold text-slate-800">Căn cứ tính lương:</span> Theo mức lương tháng 12/2025.
                 </div>
               </li>
               <li className="flex gap-2 items-start">
                 <span className="text-indigo-500 font-bold">•</span>
                 <div>
                   <span className="font-bold text-slate-800">Lương tính thưởng T13:</span> <br/>
                   <span>Tổng lương - Tiền Chuyên cần</span>
                 </div>
               </li>
               <li className="flex gap-2 items-start">
                 <span className="text-emerald-600 font-bold">•</span>
                 <div>
                   <span className="font-bold text-slate-800">Tiền thưởng T13:</span> <br/>
                   <span className="font-mono bg-slate-200/50 px-1 py-0.5 rounded text-[9px] text-slate-700 inline-block mt-0.5">(Lương tính thưởng x Hệ số x (Ngày công làm việc / 365)</span>
                 </div>
               </li>
               <li className="flex gap-2 items-start">
                 <span className="text-emerald-600 font-bold">•</span>
                 <div>
                   <span className="font-bold text-slate-800">Tiền phép năm:</span> <br/>
                   <span className="font-mono bg-slate-200/50 px-1 py-0.5 rounded text-[9px] text-slate-700 inline-block mt-0.5">(Tổng lương / 26 ngày / 8 giờ) x Số tiếng phép dư</span>
                 </div>
               </li>
               <li className="flex gap-2 items-start">
                 <span className="text-rose-500 font-bold">•</span>
                 <div>
                   <span className="font-bold text-slate-800">Tiền trừ biên bản:</span> <br/>
                   <span className="font-mono bg-slate-200/50 px-1 py-0.5 rounded text-[9px] text-slate-700 inline-block mt-0.5">((Tổng lương - Chuyên cần) / 26) x Số biên bản x 4</span>
                 </div>
               </li>
               <li className="flex gap-2 items-start">
                 <span className="text-rose-500 font-bold">•</span>
                 <div>
                   <span className="font-bold text-slate-800">Ngày Công:</span> <br/>
                   <span className="font-mono bg-slate-200/50 px-1 py-0.5 rounded text-[9px] text-slate-700 inline-block mt-0.5">Số ngày công làm việc trong năm không bao gồm ngày nghỉ không lương (Phép bệnh và việc riêng)</span>
                 </div>
               </li>
            </ul>
          </div>
        </div>
        
        <p className="text-center text-[9px] text-gray-300 mt-6 pb-2 uppercase tracking-widest">Payroll System 2026</p>
      </div>
    </div>
  );
};

export default App;